import React, { useState } from 'react';
import { OutsideClickHandler } from '../../../components';
import ProfileIconCard from '../../../components/ProfileIconCard/ProfileIconCard';
import css from './SearchSortingOptions.module.css';

const DownArrowIcon = () => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 7.35723C6.91803 7.35826 6.83676 7.34164 6.76141 7.30842C6.68606 7.27521 6.61831 7.22614 6.5625 7.16438L0.9375 1.37866C0.6875 1.12152 0.6875 0.722949 0.9375 0.465806C1.1875 0.208664 1.575 0.208664 1.825 0.465806L7.0125 5.80152L12.1875 0.478664C12.4375 0.221521 12.825 0.221521 13.075 0.478664C13.325 0.735806 13.325 1.13438 13.075 1.39152L7.45 7.17724C7.325 7.30581 7.1625 7.37009 7.0125 7.37009L7 7.35723Z"
      fill="#2F0F48"
    />
  </svg>
);

const SearchSortingOptions = props => {
  const { sortingOptions, handleFilterOptions, sort, setSortingOption } = props;
  const [isOpen, setIsOpen] = useState(false);
  const handleOnClick = option => {
    setSortingOption(option);
    handleFilterOptions(option);
    setIsOpen(false);
  };

  const selectedLabel = sort
    ? sortingOptions?.find(option => option.value === sort)?.label
    : 'Newest';

  return (
    <div className={css.sortWrapper}>
      <OutsideClickHandler onOutsideClick={() => isOpen && setIsOpen(false)}>
        <div
          data-testid="group-search-sort-filter"
          onClick={() => setIsOpen(!isOpen)}
          className={`${css.sortFilter} ${isOpen ? css.open : ''}`}
        >
          <span className={css.desktopIcon}>
            <ProfileIconCard type="sort" />
          </span>
          <span className={css.mobileIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 17 17" fill="none">
              <path fill="none" d="M5.37417 13.4352V6.71758M7.38946 11.4199L5.37417 13.4352L3.35889 11.4199M10.7483 2.68701V9.40463M8.73298 4.7023L10.7483 2.68701L12.7635 4.7023" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className={css.sortLabel}>
            <span className={css.sortPrefix}>Sort</span>
            {selectedLabel}
          </span>
        </div>
        {isOpen && (
          <div className={css.dropdownMenu}>
            <ul>
              {sortingOptions.map(option => (
                <li
                  key={option.value}
                  data-testid={`group-search-sort-option-${option.value}`}
                  onClick={() => handleOnClick(option.value)}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </OutsideClickHandler>
    </div>
  );
};

export default SearchSortingOptions;
